import Link from 'next/link';
import React from 'react';

import { ReactComponent as ArrowIcon } from '../../../_icons/chevron-right-white.svg';
import { TagWrapper } from '../default-button/components/tag-wrapper/tag-wrapper';

import styles from './link-button.module.scss';

export const LinkButton: React.FC<{
  label: string;
  light?: boolean;
  link?: string;
}> = ({ label, light, link }) => {
  return (
    <Link key={link} href={link || ''} className={styles.linkButton}>
      <TagWrapper label={label} light={light}>
        <ArrowIcon className={styles.icon} />
      </TagWrapper>
    </Link>
  );
};
